export enum ClientType {
  Limited = 7,
  Individual = 4,
  'Sole Trader' = 1,
  Partnership = 2,
  LLP = 3,
  Trust = 5,
  Charity = 6,
}